import React, {useState, useEffect} from 'react'
import {Button} from '@thryvlabs/maverick'

function QuantityComponent({minQuantity, maxQuantity, currentCount, setCount}) {
  const [inputValue, setInputValue] = useState(String(currentCount))

  useEffect(() => {
    setInputValue(String(currentCount))
  }, [currentCount])

  const handleCount = type => {
    if (type === 'increment') {
      setCount(prev => prev + 1)
    } else {
      setCount(prev => prev - 1)
    }
  }

  const handleBlur = () => {
    const val = Number(inputValue)
    const clamped = isNaN(val)
      ? minQuantity
      : Math.min(maxQuantity, Math.max(minQuantity, val))
    setCount(clamped)
    setInputValue(String(clamped))
  }

  return (
    <>
      <div className="d-flex align-items-center ">
        <Button
          disabled={currentCount === minQuantity}
          variant="primary"
          buttonType="outlined"
          onClick={() => handleCount('decrement')}
          className="fontSizeUpdate"
        >
          -
        </Button>
        &nbsp;
        <input
          type="text"
          value={inputValue}
          onChange={e => {
            if (!/^\d*$/.test(e.target.value)) return
            setInputValue(e.target.value)
          }}
          onBlur={handleBlur}
          style={{width: '48px', textAlign: 'center'}}
        />
        &nbsp;
        <Button
          disabled={currentCount === maxQuantity}
          variant="primary"
          buttonType="outlined"
          onClick={() => handleCount('increment')}
          className="fontSizeUpdate"
        >
          +
        </Button>
      </div>
    </>
  )
}

export {QuantityComponent}
